import React, { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column, ColumnEditorOptions } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { DataTableRowEditCompleteEvent } from "primereact/datatable";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import gaanaService from "../../services/desiriGaana/gaanaservice";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import desiriBullService from "../../services/desiriBull/bullservice";

interface Props {
  data: any[];
  onRefresh: () => void;
}

const DesiriGaanaTable: React.FC<Props> = ({ data, onRefresh }) => {
  const toast = useRef<Toast>(null);
  const [gaanaData, setGaanaData] = useState(data);
  const [MUOptions, setMUOptions] = useState<
    { label: string; value: number }[]
  >([]);
  const sortedData = [...gaanaData].sort((a, b) => b.id - a.id);
  const [purchasedByOptions, setpurchasedByOptions] = useState<
    { label: string; value: number }[]
  >([]);

  const onRowEditComplete = async (event: DataTableRowEditCompleteEvent) => {
    const { newData, index } = event;

    const errors: string[] = [];
    if (!newData.gaanaNumber) errors.push("Gaana Number is required");
    if (!newData.gaanaName?.trim()) errors.push("Gaana Name is required");
    if (!newData.purchasedBy) errors.push("Purchased By is required");
    if (!newData.price) errors.push("Price is required");
    if (!newData.purchasedBy) errors.push("Vendor is required");

    if (errors.length > 0) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation Error",
        detail: errors.join(", "),
        life: 4000,
      });
      return;
    }
    debugger
const payload = {
  Id: newData.id ?? gaanaData[index].id,                // number
  GaanaNumber: Number(newData.gaanaNumber),
  GaanaName: newData.gaanaName?.trim() || "",
    purchasedBy: newData.vendorID ?? 0,
  // PurchasedBy: newData.purchasedBy?.trim() || "",      // string
  PurchasedDate: newData.purchasedDate
    ? new Date(newData.purchasedDate).toISOString()
    : null,
  Price: Number(newData.price) || 0,
  InstalledDate: newData.installedDate
    ? new Date(newData.installedDate).toISOString()
    : null,
  PosId: Number(newData.posID) || 0,                   // match backend field
  IsOperational: Boolean(newData.isOperational),
  LastServicedDate: newData.lastServicedDate
    ? new Date(newData.lastServicedDate).toISOString()
    : null,
};



    try {
      const res = await gaanaService.updateGaanaDetails(payload);
      if (res.isSuccess) {
        const updatedData = [...gaanaData];
        updatedData[index] = { ...gaanaData[index], ...newData };
        setGaanaData(updatedData);
        toast.current?.show({
          severity: "success",
          summary: "Update Gaana",
          detail: res.message,
          life: 3000,
        });
        onRefresh();
      } else {
        toast.current?.show({
          severity: "warn",
          summary: "Update Gaana",
          detail: res.message || "Failed to update Gaana.",
          life: 3000,
        });
      }
    } catch (error) {
      console.error("Error updating Gaana:", error);
      toast.current?.show({
        severity: "error",
        summary: "Update Gaana",
        detail: "An error occurred while updating the Gaana.",
        life: 3000,
      });
    }
  };

  const confirmDelete = (rowData: any) => {
    confirmDialog({
      message: `Are you sure you want to delete "${rowData.gaanaName}"?`,
      header: "Confirm Deletion",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept: () => handleDelete(rowData),
    });
  };
  useEffect(() => {
    setGaanaData(data);
  }, [data]);
  const handleDelete = async (rowData: any) => {
    try {
      const res = await gaanaService.deleteGaana(rowData.id);
      if (res.isSuccess) {
        setGaanaData((prev) => prev.filter((g) => g.id !== rowData.id));
        toast.current?.show({
          severity: "success",
          summary: "Delete Gaana",
          detail: res.message,
          life: 3000,
        });
        onRefresh();
      } else {
        toast.current?.show({
          severity: "warn",
          summary: "Delete Gaana",
          detail: res.message || "Failed to delete Gaana.",
          life: 3000,
        });
      }
    } catch (error) {
      console.error("Error deleting Gaana:", error);
      toast.current?.show({
        severity: "error",
        summary: "Delete Gaana",
        detail: "An error occurred while deleting the Gaana.",
        life: 3000,
      });
    }
  };
  const textEditor = (options: ColumnEditorOptions) => {
    return (
      <InputText
        type="text"
        value={options.value}
        style={{ width: "90%", border: "1px solid #090" }}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          options.editorCallback!(e.target.value)
        }
      />
    );
  };
  const dobEditor = (options: any) => {
    return (
      <Calendar
        value={options.value ? new Date(options.value) : null}
        onChange={(e) => {
          if (e.value instanceof Date) {
            const isoDate = e.value.toLocaleDateString("en-CA");
            options.editorCallback(isoDate);
          } else {
            options.editorCallback(null);
          }
        }}
        dateFormat="yy-mm-dd"
        className="w-full"
      />
    );
  };
  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const response = await gaanaService.getAllVendors();
        const formatted = response.map((vendor: any) => ({
          label: vendor.firmInfo,
          value: vendor.vendorID,
        }));
        setpurchasedByOptions(formatted);
      } catch (error) {
        console.error("Error fetching vendors:", error);
      }
    };

    fetchVendors();
  }, []);

  const isForBreedingOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];

  const isForBreedingEditor = (options: any) => (
    <Dropdown
      value={options.value}
      options={isForBreedingOptions}
      onChange={(e) => options.editorCallback(e.value)}
      placeholder="Select Operational"
      className="w-full"
    />
  );
  const muEditor = (options: any) => {
    return (
      <Dropdown
        value={Number(options.value) || Number(options.rowData.posID)}
        options={MUOptions}
        onChange={(e) => options.editorCallback(e.value)}
        placeholder="Select Manufacturing Unit"
        filter
        showClear
        className="w-full"
      />
    );
  };
  useEffect(() => {
    const fetchMUPlants = async () => {
      try {
        const response = await desiriBullService.getAllMUPlants();
        const formatted = response.map((d: any) => ({
          label: d.posName,
          value: d.posID,
        }));
        setMUOptions(formatted);
      } catch (error) {
        console.error("Failed to load Manufacture Plants:", error);
      }
    };

    fetchMUPlants();
  }, []);
  // const purchasedByEditor = (options: any) => (
  //   <Dropdown
  //     value={Number(options.value) || Number(options.rowData.purchasedBy)}
  //     options={purchasedByOptions}
  //     onChange={(e) => options.editorCallback(e.value)}
  //     placeholder="Select Vendor"
  //     filter
  //     showClear
  //     className="w-full"
  //   />
  // );
const purchasedByEditor = (options: ColumnEditorOptions) => (
  <Dropdown
    value={options.value || options.rowData.purchasedBy} // ID
    options={purchasedByOptions}                        // { label, value }
    onChange={(e) => options.editorCallback?.(e.value)} // store ID
    placeholder="Select Vendor"
    filter
    showClear
    className="w-full"
  />
);


  return (
    <div className="col-12">
      <Toast ref={toast} />
      <div className="card p-2">
        <ConfirmDialog />
        <DataTable
          value={sortedData}
          paginator
          editMode="row"
          rows={5}
          onRowEditComplete={onRowEditComplete}
          rowsPerPageOptions={[5, 10, 25, 50]}
          stripedRows
          dataKey="id"
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
           scrollHeight=""  
           scrollable 
        >
          <Column
            field="gaanaNumber"
            header="Gaana Number"
            sortable
            style={{ width: "25%" }}
            editor={textEditor}
          />
          <Column
            field="gaanaName"
            header="Gaana Name"
            sortable
            style={{ width: "25%" }}
            editor={textEditor}
          />

          {/* <Column
            field="purchasedBy"
            header="Purchased By"
            body={(rowData) => {
              let selected = purchasedByOptions.find(
                (p) => Number(p.value) === Number(rowData.purchasedBy)
              );
              if (!selected) {
                selected = purchasedByOptions.find(
                  (p) =>
                    p.label?.toLowerCase() ===
                    String(rowData.purchasedBy).toLowerCase()
                );
              }

              return selected ? selected.label : "";
            }}
            editor={purchasedByEditor}
            sortable
          /> */}
<Column
  field="vendorID"              // store ID in the row data
  header="Purchased By"
  body={(rowData) => rowData.purchasedBy || ""} // display name from API
  editor={(options) => (
    <Dropdown
      value={options.value ?? options.rowData.vendorID}  // numeric ID
      options={purchasedByOptions}                       // [{ label, value }]
      onChange={(e) => {
        options.editorCallback?.(e.value);              // store selected ID
        // also update the displayed name in rowData
        const selected = purchasedByOptions.find(p => p.value === e.value);
        if (selected) options.rowData.purchasedBy = selected.label;
      }}
      placeholder="Select Vendor"
      filter
      showClear
      className="w-full"
    />
  )}
  sortable
/>



          <Column
            field="purchasedDate"
            header="Purchased Date"
            body={(row) => {
              if (!row.purchasedDate) return "";
              const date = new Date(row.purchasedDate);
              const day = String(date.getDate()).padStart(2, "0");
              const month = String(date.getMonth() + 1).padStart(2, "0");
              const year = String(date.getFullYear()).slice(-2);
              return `${day}/${month}/${year}`;
            }}
            editor={dobEditor}
            sortable
            style={{ width: "25%" }}
          />
          <Column
            field="posName"
            header="Manufacturing Unit"
            body={(rowData) => {
              const mu = MUOptions.find(
                (m) => Number(m.value) === Number(rowData.posID)
              );
              return mu ? mu.label : rowData.posName || "";
            }}
            editor={muEditor}
            sortable
            
            style={{ width: "25%" }}
          />

          <Column
            field="price"
            header="Price"
            sortable
            style={{ width: "25%" }}
            editor={textEditor}
          />
          <Column
            field="installedDate"
            header="Installed Date"
            body={(row) => {
              if (!row.installedDate) return "";
              const date = new Date(row.installedDate);
              const day = String(date.getDate()).padStart(2, "0");
              const month = String(date.getMonth() + 1).padStart(2, "0");
              const year = String(date.getFullYear()).slice(-2);
              return `${day}/${month}/${year}`;
            }}
            editor={dobEditor}
            sortable
            style={{ width: "25%" }}
          />
          <Column
            field="isOperational"
            header="Is Operational"
            editor={isForBreedingEditor}
            body={(row) => (row.isOperational ? "Yes" : "No")}
            style={{ width: "25%" }}
            sortable
          />
          <Column
            field="lastServicedDate"
            header="Last Serviced"
            body={(row) => {
              if (!row.lastServicedDate) return "";
              const date = new Date(row.lastServicedDate);
              const day = String(date.getDate()).padStart(2, "0");
              const month = String(date.getMonth() + 1).padStart(2, "0");
              const year = String(date.getFullYear()).slice(-2);
              return `${day}/${month}/${year}`;
            }}
            editor={dobEditor}
            sortable
            style={{ width: "25%" }}
          />
          <Column
            rowEditor
            header="Action"
            headerStyle={{ textAlign: "right" }}
            frozen
            alignFrozen="right"
          />
          <Column
            header="Delete"
            body={(rowData) => (
              <Button
                icon="pi pi-trash"
                onClick={() => confirmDelete(rowData)}
                className="p-button-rounded p-button-danger p-button-text"
              />
            )}
            style={{ width: "8%" }}
              frozen
            alignFrozen="right"
          />
        </DataTable>
      </div>
    </div>
  );
};

export default DesiriGaanaTable;
